<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'SocialRespCenter',
            to: {
              name: 'SocialRespCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'SocialRespEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改案例</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 社會責任 -->
    <SocialRespCreateEdit></SocialRespCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SocialRespCreateEdit from '@/views/B-11__SOCIALRESP/c/SocialRespCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    SocialRespCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('socialresponsibility', ['socialresponsibility']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getsocialResp(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('socialresponsibility', {
      getsocialResp: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'SocialRespCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.socialresponsibility.title) {
            this.errors.push('標題 required.');
          }/* else if (!this.socialresponsibility.slug) {
            this.errors.push('Slug required.');
          } */
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.socialresponsibility).then(() => {
            this.$router.push({ name: 'SocialRespCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
